import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';

type ChainOption = components['schemas']['ChainOption'];

const REQUEST_TYPE: keyof typeof apiConfig = 'get chains with menu';

const DEFAULT_DATA: ChainOption[] = [];

async function getChainsWithMenu(): Promise<ChainOption[]> {
    const response: ChainOption[] = await http.get(REQUEST_TYPE);
    return response ?? [];
}

export function useChainsWithMenu() {
    return useData(DEFAULT_DATA, getChainsWithMenu);
}
